import React, { useState } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Categories } from "ceicons";
import { useTranslation } from "ceco-polyglot";
import { ImageDropzone } from "../../ImageDropzone";
import { commitMutation } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import environment from "../../../environment";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";

import "./categoryModal.scss";

export default function CategoryModal(props) {
  const { trigger, edit = false, category, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState();
  const [fileError, setFileError] = useState();
  const [formErrors, setFormErrors] = useState();

  const t = useTranslation();

  function editCategory() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
      };
      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }

      commitMutation(environment, {
        mutation: CategoryModalUpdateMutation,
        variables,
        uploadables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function handleChange(evt) {
    const { value } = evt.target;
    setFormData({
      ...formData,
      [evt.target.name]: value,
    });
  }

  function createCategory() {
    return new Promise((resolve, reject) => {
      const variables = { ...formData };

      let uploadables;
      if (file) {
        uploadables = {
          imageFile: file.file[0],
        };
      }
      commitMutation(environment, {
        mutation: CategoryModalCreateMutation,
        variables,
        uploadables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }
  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? createCategory : editCategory;
      const msg = !edit
        ? t("message.created_category")
        : t("message.edited_category");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e.errors[0].message);
          }
        });
    }
  };

  const validateForm = () => {
    let errors = {};
    let validate = true;
    if (!formData.name) {
      errors = { ...errors, name: t("form.errorRequired") };
    }
    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  return (
    <BasicModal
      size="tiny"
      className="single-button"
      title={
        <div className="modalTitle">
          <Categories />
          {edit ? t("modalTitle.editCategory") : t("modalTitle.createCategory")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit ? setFormData(category) : setFormData({});
          setFile();
        },
      })}
      actions={
        <Button
          type="submit"
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <ImageDropzone
          circular
          file={file}
          setFile={setFile}
          fileError={fileError}
          setFileError={setFileError}
          imgLoaded={edit && formData.picture}
        />
        <Form.Input
          name="name"
          error={formErrors && formErrors["name"]}
          value={formData.name || ""}
          label={t("form.name")}
          placeholder={t("form.name")}
          onChange={handleChange}
          required
        />
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}
const CategoryModalCreateMutation = graphql`
  mutation CategoryModalCreateMutation($name: String) {
    recipeCategoryCreate(input: { name: $name }) {
      recipeCategory {
        id
        name
      }
    }
  }
`;
const CategoryModalUpdateMutation = graphql`
  mutation CategoryModalUpdateMutation($id: ID!, $name: String) {
    recipeCategoryUpdate(input: { id: $id, name: $name }) {
      recipeCategory {
        id
        name
        picture
      }
    }
  }
`;
